export class ChangeUserPassDto{
    oldPassword: string
    password: string;
    confirmPassword: string;
}
